define('utils',['services/viewport', 'underscore', 'services/platform.service'], function (Viewport, _, PlatformService) {

    // replaces console object if it does not exist.
    var noop = function () {
        },
        console = window.console || {};
    console.log = console.log || noop;
    console.warn = console.warn || noop;
    console.error = console.error || noop;
    console.info = console.info || noop;
    console.dir = console.dir || noop;
    console.time = console.time || noop;
    console.timeEnd = console.timeEnd || noop;
    console.trace = console.trace || noop;

    return {
        log: console.log.bind(console),
        warn: console.warn.bind(console),
        error: console.error.bind(console),
        info: console.info.bind(console),
        dir: console.dir.bind(console),
        time: console.time.bind(console),
        timeEnd: console.timeEnd.bind(console),
        trace: console.trace.bind(console),

        nullId: '000000000000000000000000',

        between: function (value, min, max) {
            return Math.max(Math.min(max, value), min);
        },

        toApiMessages: function (code) {
            return code.replace(/_/g, '-');
        },

        getSavedLanguage: function () {
            if (localStorage.getItem('i18nLng')) {
                return localStorage.getItem('i18nLng');
            } else if (this.getCookieByName('i18n')) {
                return this.getCookieByName('i18n');
            } else {
                return 'en-CA';
            }
        },

        /**
         * Snippet found on https://www.w3resource.com/javascript-exercises/javascript-string-exercise-35.php
         */
        stripHtmlTags: function (str) {
            return str.toString().replace(/<[^>]*>/g, '');
        },

        parseQueryString: function (queryString) {
            var params = {};
            if (queryString) {
                _.each(
                    _.map(decodeURI(queryString).split(/&/g), function (el, i) {
                        var aux = el.split('='), o = {};
                        if (aux.length >= 1) {
                            var val = undefined;
                            if (aux.length == 2)
                                val = aux[1];
                            o[aux[0]] = val;
                        }
                        return o;
                    }),
                    function (o) {
                        _.extend(params, o);
                    }
                );
            }
            return params;
        },

        /**
         * From https://www.sitepoint.com/url-parameters-jquery/
         */
        urlParam: function (name) {
            var results = new RegExp('[\?&]' + name + '=([^]*)').exec(window.location.href);
            if (results == null) {
                return null;
            } else {
                return results[1] || 0;
            }
        },

        displayRatingPopup: function() {
            // App Review using Capacitor plugin
            if (PlatformService.isNative()) {
                console.log('Requesting in-app review');
                if (window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.AppReview) {
                    window.Capacitor.Plugins.AppReview.requestReview()
                        .then(function() {
                            console.log('In-app review requested successfully');
                        })
                        .catch(function(error) {
                            console.error('Failed to request in-app review:', error);
                        });
                } else {
                    console.warn('AppReview plugin not available');
                }
            }
        },

        getCookieByName: function (cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },

        deleteCookieByName: function (cname) {
            document.cookie = cname + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        },

        showIntercom: function () {
            if (PlatformService.isNative()) {
                window.Intercom('update', {hide_default_launcher: false});
            }
        },

        hideIntercom: function () {
            if (PlatformService.isNative()) {
                window.Intercom('update', {hide_default_launcher: true});
            }
        },

        // Workaround to make sure redirection works on all major browsers
        delayRedirect: function (url, delay) {
            window.setTimeout(function () {
                window.location.href = url;
            }, delay || 500);
        }

    };

});

